/**
 * Flow group action creation.
 * Duplicated from Scenes for Flow independence.
 */

import { delay_action } from './device-actions';

export interface FlowGroupActionInput {
	groupId: string | number;
	actionName: string;
	actionValue: string | number | boolean;
	position?: number;
	direction?: string;
	delay?: { value: number; units: string };
}

/**
 * Creates a group action payload for scene JSON.
 */
export function createGroupActionFromFlow(input: FlowGroupActionInput): Record<string, unknown> {
	const action: Record<string, unknown> = {
		grpctrl: Number(input.groupId),
		[input.actionName]: input.actionValue,
		_gui_type: 'group_action',
	};

	if (input.position !== undefined) {
		action.position = input.position;
	}
	if (input.direction !== undefined) {
		action.direction = input.direction;
	}

	if (input.delay != null && Number(input.delay.value) > 0) {
		return delay_action(action, input.delay) as Record<string, unknown>;
	}

	return action;
}
